
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/box","xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#697485"}},[_c('g',{attrs:{"data-name":"Group 139","opacity":".4"}},[_c('path',{attrs:{"d":"M10 11.083a.625.625 0 01-.313-.084L2.329 6.741a.625.625 0 01-.228-.854.625.625 0 01.854-.228L10 9.736l7-4.052a.625.625 0 01.854.228.625.625 0 01-.228.854l-7.312 4.233a.625.625 0 01-.314.084z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10 18.633a.625.625 0 01-.625-.625V10.45A.625.625 0 0110 9.825a.625.625 0 01.625.625v7.558a.625.625 0 01-.625.625z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10.001 1.042a4.258 4.258 0 012.036.479l4.45 2.471a4.543 4.543 0 012.155 3.655v4.708a4.543 4.543 0 01-2.156 3.655l-4.449 2.482a4.275 4.275 0 01-2.033.473 4.274 4.274 0 01-2.031-.473l-4.456-2.479a4.543 4.543 0 01-2.15-3.654V7.65a4.543 4.543 0 012.156-3.658l4.449-2.471a4.219 4.219 0 012.029-.479zm0 16.669a3.06 3.06 0 001.43-.319l4.449-2.474a3.333 3.333 0 001.512-2.562V7.65a3.333 3.333 0 00-1.511-2.558L11.43 2.613a3.043 3.043 0 00-1.429-.321 3.006 3.006 0 00-1.42.32l-4.452 2.48A3.333 3.333 0 002.617 7.65v4.708a3.333 3.333 0 001.511 2.562l4.451 2.472a3.06 3.06 0 001.425.319z"}})]),_c('path',{attrs:{"data-name":"Vector","d":"M14.166 11.659a.625.625 0 01-.625-.625V8.342L5.945 3.958a.625.625 0 01-.228-.854.625.625 0 01.854-.228l7.912 4.566a.625.625 0 01.312.541v3.05a.625.625 0 01-.629.626z"}})])])
          )
        }
      }
    